
export const SET_SEND_DETAIL = 'SET_SEND_DETAIL'

export const SET_RECE_DETAIL = 'SET_RECE_DETAIL'

export const SET_WEIGHT = 'SET_WEIGHT'

export const SET_ADDRESS_TREE = 'SET_ADDRESS_TREE'

export const SET_CONSOLE_TIPS_LIST = 'SET_CONSOLE_TIPS_LIST'

export const SET_TIPS_ACTIVE = 'SET_TIPS_ACTIVE' // 选中的说明（重量 保价 计泡 ）

export const SET_PAGE_CACHE = 'SET_PAGE_CACHE' // 页面缓存

export const STE_TAB_ACTIVE = 'STE_TAB_ACTIVE' // tab切换

export const SET_USER_INFO = 'SET_USER_INFO' // 设置用户登陆信息
export const SET_USER_NAME = 'SET_USER_NAME' // 设置用户名
export const SET_USER_PHONE = 'SET_USER_PHONE' // 设置用户手机号码
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS' // 设置用户登录状态
export const SET_SERVER_OPENID = 'SET_SERVER_OPENID' // 设置用户openId
